import { useEffect, useState } from "react";
import { Box, Button } from "src/components/MuiGenerals";
import VersionTabs from "src/components/VersionTabs";
import { useAlerting } from "src/hooks";
import { customSx } from "src/utils/styling";
import { useBatchApproveAllowancePreviewContext } from "../../contexts";
import Summary from "./components/Summary";
import Table from "./components/Table";
import { amountDivideDecimals } from "src/utils/helper";

function Preview() {
  const {
    previewData,
    onSubmit,
    onReset,
    translate,
    setWalletMajorVersion,
    tabsArr,
    setSendingAddressesMap,
    walletMajorVersion,
  } = useBatchApproveAllowancePreviewContext();

  if (!previewData || !previewData.addressData.length) {
    return null;
  }

  return (
    <Box
      sx={{
        ...customSx.layoutBox,
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
      }}>
      <VersionTabs
        tabsArr={tabsArr}
        walletMajorVersion={walletMajorVersion}
        setWalletMajorVersion={(walletMajorVersion) => {
          setWalletMajorVersion(walletMajorVersion);
          setSendingAddressesMap(
            new Map(
              previewData.addressData
                .filter(
                  (item) => item.wallet_major_version === walletMajorVersion,
                )
                .map(
                  ({
                    wallet_address,
                    wallet_balance,
                    decimals,
                    wallet_type,
                    wallet_major_version,
                  }) => [
                    wallet_address,
                    {
                      walletBalance: amountDivideDecimals(
                        wallet_balance,
                        decimals,
                      ),
                      walletType: wallet_type,
                      isSelected: true,
                      walletMajorVersion: wallet_major_version,
                    },
                  ],
                ),
            ),
          );
        }}
      />
      <Summary />
      <Table />
      <div style={{ display: "flex", justifyContent: "center", gap: "1rem" }}>
        <Button
          onClick={onSubmit}
          // sx={sx.preview}
          color="secondary"
          variant="contained">
          {translate("submit")}
        </Button>
        <Button
          onClick={onReset}
          // sx={sx.preview}
          color="info"
          variant="contained">
          {translate("reset")}
        </Button>
      </div>
    </Box>
  );
}

export default Preview;
